import { Modal } from '@sede-x/shell-ds-react-framework';
import styled from 'styled-components';

export const StyledModal = styled(Modal)``;
